import gql from "graphql-tag";

export const CUSTOM_LOGIN = gql`
  query Login($mobileNumber: String!, $loginType: LOGIN_TYPE!) {
    login(mobileNumber: $mobileNumber, loginType: $loginType) {
      status
      message
      loginId
    }
  }
`;

export const SEND_EMAIL_OTP = gql`
  query GenerateOtpEmailId($GenerateOtpEmailIdInput: GenerateOtpEmailIdInput) {
    GenerateOtpEmailId(GenerateOtpEmailIdInput: $GenerateOtpEmailIdInput) {
      status
      message
      loginId
    }
  }
`;

export const GET_OTP_ON_CALL = gql`
  query getOTPOnCall(
    $mobileNumber: String
    $loginType: LOGIN_TYPE
    $id: String!
  ) {
    getOTPOnCall(mobileNumber: $mobileNumber, loginType: $loginType, id: $id) {
      status
      loginId
      message
    }
  }
`;

export const CUSTOM_LOGIN_RESEND_OTP = gql`
  query ResendOtp(
    $mobileNumber: String!
    $id: String!
    $loginType: LOGIN_TYPE!
  ) {
    resendOtp(mobileNumber: $mobileNumber, id: $id, loginType: $loginType) {
      status
      message
      loginId
    }
  }
`;

export const CUSTOM_LOGIN_VERIFY_OTP = gql`
  query verifyLoginOtp($otpVerificationInput: OtpVerificationInput) {
    verifyLoginOtp(otpVerificationInput: $otpVerificationInput) {
      status
      authToken
      isBlocked
      reason
      incorrectAttempts
      mobileNumber
    }
  }
`;

export const HDFC_LOGIN = gql`
  query loginHdfc($mobileNumber: String!, $DOB: Date!) {
    loginHdfc(mobileNumber: $mobileNumber, DOB: $DOB) {
      status
      token
      responseCode
      id
    }
  }
`;

export const VERIFY_HDFC_OTP = gql`
  query validateLoginHdfcOTP(
    $id: String!
    $otp: String!
    $token: String!
    $DOB: Date!
  ) {
    validateLoginHdfcOTP(id: $id, otp: $otp, token: $token, DOB: $DOB) {
      status
      defaultPlan
      responseCode
      reason
      authToken
      isBlocked
      incorrectAttempts
    }
  }
`;
